<script lang="ts">
  import { getHref } from 'customer-components/lib/helpers/sections-helper';
  import { getContext } from 'svelte';
  import { MenuBurger, MenuClose } from './components/icons';
  import { asideShow } from './store/header';
  import { ListItem, Aside, Logo } from './components/header';
  import { PhoneIcon, PhoneAltIcon } from './components/icons';
  import { sendEvent } from './helpers/GoogleAnalytics';
  import { Button } from './v2/elements';
  import { Button as Button2 } from './components';
  import type {
    GlobalProperties,
    UseFormattedProps,
    Country,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;
  // todo: where is this location coming from?
  // response: can be removed including the html stuff that it renders
  export let location = '';

  const country = getContext<Country>('country');
  const lpKey = getContext<string>('lpKey');
  const isEditable = getContext<boolean>('isEditable');

  $: ({ generalSettings, brand, background, color, borderRadius } = settings);

  $: phoneNumber = generalSettings?.contacts?.phone?.value;
  $: button = properties.button;
</script>

<header>
  <div
    class="header-container {properties.sticky || $asideShow ? 'sticky' : ''}"
    id={properties?.anchor}
  >
    <div class="header-content">
      <div class="left-content {properties.style}">
        <a href="/" class="header-logo-link {properties.style}">
          {#if brand?.custom.active || brand?.default.active}
            <Logo {brand} />
          {/if}

          {#if brand?.text.active}
            <div class="logo-text" style="color:var(--vlt-lp-background-text);">
              <p>{brand.text.value}</p>
            </div>
          {/if}
        </a>

        <div class="list {properties.style}">
          {#if properties.links?.active}
            <nav class="header-nav-menu">
              <ul>
                {#each properties.links.items as link}
                  <li class="list-item">
                    <ListItem
                      url={link.url}
                      label={link.label}
                      type={link.type}
                      nestedItems={link.nestedItems}
                      isHeader={true}
                    />
                  </li>
                {/each}
              </ul>
            </nav>
          {/if}
        </div>
      </div>
      {#if location.split(',')[0]}
        <div
          class="location-header-desktop"
          style="display:flex;flex-shrink:0;padding:0px 10px;grid-gap:5px;align-items:center;font-size:20px;font-weight:700;"
        >
          <svg
            style="color:#c00;"
            width="24px"
            height="24px"
            fill="currentColor"
            viewBox="0 0 395.71 395.71"
            xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m197.85 0c-75.718 0-137.32 61.609-137.32 137.33 0 72.887 124.59 243.18 129.9 250.39l4.951 6.738c0.579 0.792 1.501 1.255 2.471 1.255 0.985 0 1.901-0.463 2.486-1.255l4.948-6.738c5.308-7.211 129.9-177.5 129.9-250.39 0-75.72-61.61-137.33-137.33-137.33zm0 88.138c27.13 0 49.191 22.062 49.191 49.191 0 27.115-22.062 49.191-49.191 49.191-27.114 0-49.191-22.076-49.191-49.191 0-27.129 22.076-49.191 49.191-49.191z"
            />
          </svg>
          {location.split(',')[0]}
        </div>
      {/if}

      <div class="right">
        <div class="menu">
          {#if !$asideShow}
            <button
              class="btn-menu"
              aria-label="menu"
              on:click={() => {
                // menu should only be opened when the page is not in edit mode
                !isEditable && asideShow.set(true);
              }}
            >
              <MenuBurger />
            </button>
          {:else}
            <button
              class="btn-menu"
              on:click={() => {
                asideShow.set(false);
              }}
            >
              <MenuClose />
            </button>
          {/if}
        </div>

        {#if button?.active}
          <div class="btn">
            {#if properties?.isCustom}
              <Button2
                isHeader
                {borderRadius}
                section="Header"
                buttonType={button.link_type}
                buttonLink={button.link}
                buttonTitle={button.label}
              />
            {:else if generalSettings?.contacts?.phone?.enabled}
              <Button href={`tel:${phoneNumber}`} {borderRadius}>
                <PhoneAltIcon />
                {generalSettings?.contacts?.phone?.value}
              </Button>
            {:else if !generalSettings?.callToAction?.value}
              <Button2
                isHeader
                {borderRadius}
                section="Header"
                buttonType={button.link_type}
                buttonLink={button.link}
                buttonTitle={button.label}
              />
            {:else}
              <Button href="#form" {borderRadius}>
                {generalSettings?.callToAction?.value === 'book-internal' ||
                generalSettings?.callToAction?.value === 'book-external'
                  ? 'Book Now'
                  : generalSettings?.callToAction?.value}
              </Button>
            {/if}
          </div>
        {/if}
      </div>
    </div>
  </div>
  {#if !properties.isCustom && generalSettings?.contacts?.phone?.enabled}
    <div
      class="mobile-header-cta"
      style="background:var(--vlt-lp-primary); color:var(--vlt-lp-primary-text);"
    >
      {#if location.split(',')[0]}
        <span>
          <svg
            width="18px"
            height="18px"
            fill="currentColor"
            version="1.1"
            viewBox="0 0 395.71 395.71"
            xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m197.85 0c-75.718 0-137.32 61.609-137.32 137.33 0 72.887 124.59 243.18 129.9 250.39l4.951 6.738c0.579 0.792 1.501 1.255 2.471 1.255 0.985 0 1.901-0.463 2.486-1.255l4.948-6.738c5.308-7.211 129.9-177.5 129.9-250.39 0-75.72-61.61-137.33-137.33-137.33zm0 88.138c27.13 0 49.191 22.062 49.191 49.191 0 27.115-22.062 49.191-49.191 49.191-27.114 0-49.191-22.076-49.191-49.191 0-27.129 22.076-49.191 49.191-49.191z"
            />
          </svg>
          {location.split(',')[0]}
        </span>
      {/if}
      <a
        href={getHref('Phone', phoneNumber)}
        on:click={() => {
          try {
            sendEvent('CTA click', {
              cta_text: button.label,
              lpKey,
              user_domain: window.location.hostname,
              section_clicked: 'header',
              country,
            });
            sendEvent('Click to call', {
              cta_text: button.label,
              user_domain: window.location.hostname,
              lpKey: lpKey,
              section_clicked: 'header',
              set_country: country,
              phone_number: button.link,
            });
          } catch (err) {
            console.log(err);
          }
        }}
      >
        <i style="font-size:12px;"><PhoneIcon /></i>
        {phoneNumber}
      </a>
    </div>
  {:else if properties.isCustom && button?.link_type === 'Phone'}
    <div
      class="mobile-header-cta"
      style="background:var(--vlt-lp-primary); color:var(--vlt-lp-primary-text);"
    >
      {#if location.split(',')[0]}
        <span>
          <svg
            width="18px"
            height="18px"
            fill="currentColor"
            version="1.1"
            viewBox="0 0 395.71 395.71"
            xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m197.85 0c-75.718 0-137.32 61.609-137.32 137.33 0 72.887 124.59 243.18 129.9 250.39l4.951 6.738c0.579 0.792 1.501 1.255 2.471 1.255 0.985 0 1.901-0.463 2.486-1.255l4.948-6.738c5.308-7.211 129.9-177.5 129.9-250.39 0-75.72-61.61-137.33-137.33-137.33zm0 88.138c27.13 0 49.191 22.062 49.191 49.191 0 27.115-22.062 49.191-49.191 49.191-27.114 0-49.191-22.076-49.191-49.191 0-27.129 22.076-49.191 49.191-49.191z"
            />
          </svg>
          {location.split(',')[0]}
        </span>
      {/if}
      <a
        href={getHref('Phone', button.link)}
        on:click={() => {
          try {
            sendEvent('CTA click', {
              cta_text: button.label,
              lpKey,
              user_domain: window.location.hostname,
              section_clicked: 'header',
              country,
            });
            sendEvent('Click to call', {
              cta_text: button.label,
              user_domain: window.location.hostname,
              lpKey: lpKey,
              section_clicked: 'header',
              set_country: country,
              phone_number: button.link,
            });
          } catch (err) {
            console.log(err);
          }
        }}
      >
        <i style="font-size:12px;"><PhoneIcon /></i>
        {button.label}
      </a>
    </div>
  {:else if properties.isCustom && button?.link_type === 'External'}
    <div
      class="mobile-header-cta"
      style="background:{background}; color:{color};"
    >
      <a
        href={button.link}
        on:click={() => {
          try {
            sendEvent('CTA click', {
              cta_text: button.label,
              lpKey: lpKey,
              user_domain: window.location.hostname,
              section_clicked: 'header',
              country: country,
            });
          } catch (err) {
            console.log(err);
          }
        }}>{button.label}</a
      >
    </div>
  {/if}
</header>
<Aside {properties} />

<style>
  header {
    position: sticky;
    top: 0;
    z-index: 9;
    background: var(--vlt-lp-background);
    color: var(--vlt-lp-text);
    padding-top: 5px;
  }
  .mobile-header-cta {
    display: none;
    background: var(--vlt-lp-primary);
    color: var(--vlt-lp-text);
    padding: 15px;
    align-items: center;
    justify-content: center;
    grid-gap: 25px;
    font-size: 17.5px;
    font-weight: 700;
  }
  .mobile-header-cta a,
  .mobile-header-cta span {
    display: inline-flex;
    align-items: center;
    grid-gap: 8px;
  }
  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1300px;
    margin: 0 auto;
    z-index: 90;
    color: var(--vlt-lp-text);
  }
  .header-container {
    width: auto;
    height: auto;
    padding: 15px 32px;
    color: var(--vlt-lp-text);
    /* background:#fff; */
  }
  .header-container.sticky {
    position: sticky;
    top: 0;
    z-index: 9999;
  }
  .list {
    display: flex;
    margin-right: 20px;
    color: var(--vlt-lp-text);
  }
  .right .btn :global(.button) {
    width: max-content;
  }
  .btn-menu {
    border: none;
    background: transparent;
    color: var(--vlt-lp-text);
  }
  .left-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .left-content.center {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .header-logo-link.logoCenter {
    order: 2;
    margin: 0 auto;
  }
  .list.logoCenter {
    margin: 0;
  }
  button {
    cursor: pointer;
  }
  .logo-text {
    word-break: break-word;
    text-decoration: none;
    margin-left: 5px;
    text-transform: uppercase;
  }
  .logo-text p {
    font-family: var(--vlt-lp-heading-font);
  }
  .header-logo-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    font-size: 16px;
    font-weight: 900;
    width: 100%;
    max-width: 300px;
  }
  ul {
    display: flex;
    align-items: center;
  }
  ul li {
    list-style-type: none;
    display: inline;
    font-size: 16px;
    line-height: 24px;
  }
  ul li:not(:first-child) {
    padding-left: 32px;
  }
  ul li:not(:first-child) {
    padding-left: 32px;
  }
  a {
    cursor: pointer;
    text-decoration: none;
    color: inherit;
  }
  .right .menu {
    display: none;
  }
  @media screen and (max-width: 900px) {
    .header-container {
      padding: 10px 20px;
    }
    .header-content .list {
      display: none;
    }
    .right .menu {
      display: block;
    }
    .right .btn {
      display: none;
    }
    .mobile-header-cta {
      display: flex;
    }
  }

  @media screen and (max-width: 767px) {
    .header-container {
      padding: 10px 15px;
    }
    .location-header-desktop {
      display: none !important;
    }
  }
</style>
